import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6acb4f0e")

_pushScopeId("data-v-6acb4f0e")
const _hoisted_1 = { class: "card__header" }
const _hoisted_2 = { class: "status" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("자세히보기")
const _hoisted_4 = { class: "card__main" }
const _hoisted_5 = { class: "card__info" }
const _hoisted_6 = { class: "card__doctor" }
const _hoisted_7 = { class: "sub -medium" }
const _hoisted_8 = { class: "main -bold" }
const _hoisted_9 = { class: "card__insertDate" }
const _hoisted_10 = { class: "main -bold" }
const _hoisted_11 = { class: "sub -medium" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_13 = { class: "card__scheduleDate" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "sub -medium" }, "예약일시", -1)
const _hoisted_15 = { class: "main -bold" }
const _hoisted_16 = { class: "card__footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RequestProgress = _resolveComponent("RequestProgress")
  const _component_router_link = _resolveComponent("router-link")
  const _component_RequestProgressDesc = _resolveComponent("RequestProgressDesc")

  return (_openBlock(), _createBlock("div", {
    class: ["request-card", _ctx.cardInfo.style]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_RequestProgress, { cardInfo: _ctx.cardInfo }, null, 8, ["cardInfo"])
      ]),
      _createVNode(_component_router_link, {
        to: _ctx.view,
        class: "detail -medium"
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.state.item.DesiredDrDeptName), 1),
          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.state.item.DesiredDrName), 1)
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("span", _hoisted_10, [
            _createVNode(_component_RequestProgressDesc, { cardInfo: _ctx.cardInfo }, null, 8, ["cardInfo"])
          ]),
          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.insertDateTime), 1)
        ])
      ]),
      (_ctx.state.kind === _ctx.RequestKindTypes.OnlineCare)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _hoisted_12,
            _createVNode("div", null, [
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode("span", _hoisted_15, _toDisplayString(_ctx.ScheduledDateTime), 1)
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_16, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cardInfo.buttons, (b, index) => {
        return (_openBlock(), _createBlock(_Fragment, { key: index }, [
          (b.type === 'link')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: ["-button", b.style],
                to: b.path()
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(b.label), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"]))
            : _createCommentVNode("", true),
          (b.type === 'button')
            ? (_openBlock(), _createBlock("button", {
                key: 1,
                class: ["-button", b.style],
                onClick: b.path
              }, _toDisplayString(b.label), 11, ["onClick"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ], 2))
})